import type { FormState } from '@vtex/admin-ui-form'
import { createContext, useContext } from 'react'
import type { DiscountType, RnbCalculatorPayload } from 'typings'

interface FormStateContextType {
  form: FormState
  readOnly: boolean
  originalValues?: RnbCalculatorPayload
  discountType: DiscountType | undefined
}

export const FormStateContext = createContext<FormStateContextType | undefined>(
  undefined
)

export function useFormStateContext() {
  const context = useContext(FormStateContext)

  if (context === undefined) {
    throw new Error(
      'formState must be defined in order to use useFormStateContext hook'
    )
  }

  return context
}

export const FormStateContextProvider = FormStateContext.Provider
